import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseSiteService, CmsService, GlobalMessageService, OccEndpointsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { MessageHistoryService } from '../message-history.service';

@Component({
    selector: 'app-message-details',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './message-details.component.html',
    styleUrls: ['./message-details.component.scss'],
    standalone: false
})
export class MessageDetailsComponent implements OnInit, OnDestroy {
  userInfo: any;
  userId: any;
  notificationSubscription: any;
  notificationData: any;
  urlSafe: any;
  urlSafeCopy: any;
  notifyData: any;
  baseSiteId: string;
  printPdf: boolean = false;
  salesOrgCode: string;
  bannerUrl: any;
  baseUrl: any;
  iframeHeight: number = 1000;
  iframeWidth: number = 960; //default value for desktop view
  printTimeout: any;
  attachmentSubscription: any;
  attachmentData: any;

  @HostListener('window:resize', ['$event'])
  checkResponsiveness(event: Event) {
    this.updateIframeWidthBasedOnScreen();
  }

  updateIframeWidthBasedOnScreen() {
    let screenWidth = window.innerWidth;
    if (window.screen.width > 1024 && window.screen.width <= 1180) {
      this.iframeWidth = screenWidth - 300;
    }
    else if (window.screen.width >= 768 && window.screen.width <= 1024) { //ipad devices width
      this.iframeWidth = screenWidth - 250;
    }
    else if (window.screen.width >= 400 && window.screen.width < 768) {
      this.iframeWidth = screenWidth - 50;
    }
    else if (window.screen.width < 400) {
      this.iframeWidth = screenWidth - 15;
    }
    else {
      this.iframeWidth = 960; //default
    }
  }

  constructor(private readonly service: MessageHistoryService,
    private readonly user: UserAccountFacade,
    private readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef,
    private baseSiteService: BaseSiteService,
    private readonly cmsService: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private _dataService: DataLayerService,
    private globalMessage: GlobalMessageService,) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {
    this.updateIframeWidthBasedOnScreen(); //to change iframe width if user using mobile device initially.
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      if (userData) {
        this.baseSiteService
          .getActive()
          .pipe(take(1))
          .subscribe((res) => {
            this.baseSiteId = res;
            if (this.baseSiteId === 'vsh') {
              this.salesOrgCode = 'US30';
            } else {
              this.salesOrgCode = 'US36';
            }
            this.getNotificationDetails();
          });


        this.userInfo?.unsubscribe();
      }
    });
    let mediabanner;
    this.cmsService
      .getComponentData('NotificationDetailsBannerComponent')
      .subscribe((res: any) => {
        mediabanner = res?.media?.url;
        if (res?.media?.url) {
          this._dataService.addtoDataLayer("view_promotion", res);
        }
      });
    if (mediabanner) {
      this.bannerUrl = this.baseUrl + mediabanner;
    }

  }
  getNotificationDetails() {
    const params = { userId: this.userId.uid };
    this.notifyData = JSON.parse(localStorage.getItem('messageId'));
    let data = {
      "salesOrg": this.salesOrgCode,
      "MESSAGE_ID": this.notifyData?.MESSAGE_ID,
      "ACCOUNT_NUMBER": this.notifyData?.ACCOUNT_NUMBER,
      "FROM_EMAIL": this.notifyData?.FROM_EMAIL,

      "NOTIFICATION_NAME": this.notifyData?.SUBJECT,
      "ORDER_NUMBER": this.notifyData?.ORDER_NUMBER,
      "TO_EMAIL": this.notifyData?.TO_EMAIL
    }
    this.service.getNotificationDetails(params, data);






    this.notificationSubscription = this.service.notificationDetails$.subscribe((res) => {
      if (res !== null) {
        this.notificationData = res;
        let messageHtml = res?.messageDetailsHtml
        this.urlSafe = this.sanitizer.bypassSecurityTrustHtml(messageHtml);
        let updatedMessageHtml = messageHtml?.replace(/max-width:640px;/g, 'max-width:100%;');
        updatedMessageHtml = updatedMessageHtml?.replace('padding: 20px;', 'padding: 10px;page-break-after: avoid;');
        this.urlSafeCopy = this.sanitizer.bypassSecurityTrustHtml(updatedMessageHtml);

        if (this.iframeWidth < 400) {
          let updatedMessageHtmlMob = messageHtml?.replace(/padding:20px;/g, 'padding: 3px;');
          updatedMessageHtmlMob = updatedMessageHtmlMob?.replace(/width:100%;/g, 'width:92%;');
          updatedMessageHtmlMob = updatedMessageHtmlMob?.replace(/width:60%;/g, 'width:60%;margin-right:5px;');
          this.urlSafe = this.sanitizer.bypassSecurityTrustHtml(updatedMessageHtmlMob);
        }
        this.cdr.detectChanges();
        this.notificationSubscription?.unsubscribe();
      }
    });
  }

  print() {
    if (this.printPdf) {

      return;
    }
    this.printPdf = true;
    this.cdr.detectChanges();
    clearTimeout(this.printTimeout);
    this.printTimeout = setTimeout(() => {
      window.print();
      this.printPdf = false;
      this.cdr.detectChanges();
    }, 1000);
  }
  ngOnDestroy(): void {
    this.userInfo?.unsubscribe();
    this.notificationSubscription?.unsubscribe();
  }
  getAttachData() {
    const params = { userId: this.userId.uid };
    this.attachmentData = JSON.parse(localStorage.getItem('messageId'));
    let attachdata = {
      "salesOrg": this.salesOrgCode,


      "accountNumber": this.attachmentData?.ACCOUNT_NUMBER,
      "messageId": this.attachmentData?.MESSAGE_ID,
      "FROM_EMAIL": this.attachmentData?.FROM_EMAIL,
      "NOTIFICATION_NAME": this.attachmentData?.SUBJECT,
      "ORDER_NUMBER": this.attachmentData?.ORDER_NUMBER,
      "TO_EMAIL": this.attachmentData?.TO_EMAIL
    }
    this.service.getAttachmentDetails(params, attachdata);
  }
}
